import React, {useMemo} from 'react';
import PropTypes from 'prop-types';

import UserAvatar from '@/components/UserAvatar';
import {getUserFullName} from '@/utils/userFullName';

const UserMenuInfo = ({ user }) => {
  const fullName = useMemo(() => getUserFullName(user), [user]);

  return (
    <div className={ 'flex flex-col items-center justify-center text-center'}>
      <UserAvatar user={user} shape="circle" size={60}/>
      <div>
        <span className={ 'ml-2 block'}>{fullName}</span>
        <span className={'ml-2 block opacity-75'}>{user?.email}</span>
      </div>
    </div>
  );
};

UserMenuInfo.propTypes = {
  user: PropTypes.object
};

export default UserMenuInfo;
